export function initServiceShow(){
    const serviceBlocks = document.querySelectorAll<HTMLElement>(".list-services");

    serviceBlocks.forEach(block => {
        const serviceItems = block.querySelectorAll<HTMLAnchorElement>(".service-items .service-item");
        const showAllButton = block.querySelector<HTMLButtonElement>(".button-show-all");

        if (!showAllButton) return;

        // Если элементов больше 4 — показываем кнопку
        if (serviceItems.length > 4) {
            showAllButton.style.display = "flex";
        }

        // Клик по кнопке
        showAllButton.addEventListener("click", () => {
            serviceItems.forEach(item => {
                item.style.display = "flex"; // показать все
            });
            showAllButton.style.display = "none"; // скрыть кнопку
        });
    });
}